import PropTypes from 'prop-types';
import StatisticsPanelSection from '../../components/StatisticsPanelSection';
import AdvancedStatistics from '../../components/StatisticsPanelSection/AdvancedStatistics';
import MultipleCountriesAttribute from '../MultipleCountriesAttribute';
import MultipleCountriesCharts from '../MultipleCountriesCharts';
// import StatisticsLayers from '../../components/StatisticsLayers';
import './style.scss';
import SwcAttribute from '../../components/SwcAttribute';

const MultipleCountriesStatistics = ({sections}) => {
	return (
		<>
			{sections.map(section => {
				const {key, title, attributes, charts, layers} = section;
				const advancedStatistics =
					charts || layers ? (
						<AdvancedStatistics>
							{/*{layers?.length ? <StatisticsLayers layers={layers} /> : null}*/}
							{charts ? <MultipleCountriesCharts charts={charts} /> : null}
						</AdvancedStatistics>
					) : null;

				return (
					<StatisticsPanelSection
						key={key}
						sectionKey={key}
						heading={title}
						AdvancedStatistics={advancedStatistics}
					>
						{attributes.map(attribute => {
							return (
								<MultipleCountriesAttribute
									key={attribute}
									attributeKey={attribute}
								/>
							);
						})}
						{key === 'surface-water-changes' ? (
							<>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Gain water - max', unit: 'sqkm'},
									}}
									attributeKey="swcmaxA"
									attributeLatestKey="swcmaxB"
									type="gain"
									store="countries"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Gain water - min', unit: 'sqkm'},
									}}
									attributeKey="swcminA"
									attributeLatestKey="swcminB"
									type="gain"
									store="countries"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Loss water - max', unit: 'sqkm'},
									}}
									attributeKey="swcmaxA"
									attributeLatestKey="swcmaxB"
									type="loss"
									store="countries"
								/>
								<SwcAttribute
									attributeMetadata={{
										data: {nameDisplay: 'Loss water - min', unit: 'sqkm'},
									}}
									attributeKey="swcminA"
									attributeLatestKey="swcminB"
									type="loss"
									store="countries"
								/>
							</>
						) : null}
					</StatisticsPanelSection>
				);
			})}
		</>
	);
};

MultipleCountriesStatistics.propTypes = {
	sections: PropTypes.array,
};

export default MultipleCountriesStatistics;
